const translations = {
  // ---- Navbar & Navigation ----
  nav: {
    dashboard: { en: 'Dashboard', am: 'ዳሽቦርድ' },
    analysis: { en: 'Analysis', am: 'ትንተና' },
    logs: { en: 'Logs', am: 'መዝገቦች' },
    settings: { en: 'Settings', am: 'ቅንብሮች' },
    home: { en: 'Home', am: 'መነሻ' },
    profile: { en: 'Profile', am: 'መገለጫ' },
    logout: { en: 'Logout', am: 'ውጣ' },
    quickScan: { en: 'Quick Scan', am: 'ፈጣን ስካን' },
    notifications: { en: 'Notifications', am: 'ማሳወቂያዎች' },
    scanForDisease: { en: 'Scan for Disease', am: 'ለበሽታ ስካን ያድርጉ' },
    markAllRead: { en: 'Mark all read', am: 'ሁሉንም አንብብ' },
    noNotifications: { en: 'No notifications yet', am: 'ምንም ማሳወቂያ የለም' },
    unread: { en: 'Unread', am: 'ያልተነበቡ' },
    all: { en: 'All', am: 'ሁሉም' },
    unreadOnly: { en: 'Unread', am: 'ያልተነበቡ' },
    allItems: { en: 'All', am: 'ሁሉም' },
    notificationsSyncing: { en: 'Background sync pauses when this tab is hidden.', am: 'ይህ ትር ሲደበቅ የጀርባ ማመሳሰል ይቆማል።' },
    admin: { en: 'Admin', am: 'አስተዳዳሪ' },
    users: { en: 'Users', am: 'ተጠቃሚዎች' },
    scans: { en: 'Scans', am: 'ምርመራዎች' },
    training: { en: 'Training', am: 'ልምምድ' },
  },
  admin: {
    manageUser: { en: 'Manage User', am: 'ተጠቃሚን ያስተዳድሩ' },
    gateways: { en: 'Gateways', am: 'ጌትዌዎች' },
    total: { en: 'Total', am: 'ጠቅላላ' },
    withImage: { en: 'With Image', am: 'ምስል ያላቸው' },
    reviewed: { en: 'Reviewed', am: 'የተገመገሙ' },
    confirmed: { en: 'Confirmed', am: 'የተረጋገጡ' },
    undo: { en: 'Undo', am: 'ወደ ኋላ መልስ' },
    systemControls: { en: 'System Controls', am: 'የስርዓት መቆጣጠሪያዎች' },
    uptime: { en: 'System Uptime', am: 'የስርዓት ስራ ጊዜ' },
    deleteUserConfirm: { en: 'Delete user "{username}" and all data? This cannot be undone.', am: 'ተጠቃሚ "{username}" እና ሁሉንም መረጃ ይጥፋ? ይህ ሊመለስ አይችልም።' },
  },

  // ---- Login / Auth ----
  auth: {
    welcomeBack: { en: 'Welcome Back', am: 'እንኳን ደህና መጡ' },
    createAccount: { en: 'Create Account', am: 'መለያ ይፍጠሩ' },
    username: { en: 'Username', am: 'የተጠቃሚ ስም' },
    password: { en: 'Password', am: 'የይለፍ ቃል' },
    email: { en: 'Email', am: 'ኢሜይል' },
    enterUsername: { en: 'Enter your username', am: 'የተጠቃሚ ስምዎን ያስገቡ' },
    enterPassword: { en: 'Enter your password', am: 'የይለፍ ቃልዎን ያስገቡ' },
    enterEmail: { en: 'Enter your email for alerts', am: 'ለማንቂያ ኢሜይልዎን ያስገቡ' },
    signIn: { en: 'Sign In', am: 'ግባ' },
    signUp: { en: 'Sign Up', am: 'ተመዝገብ' },
    pleaseWait: { en: 'Please wait...', am: 'እባክዎ ይጠብቁ...' },
    noAccount: { en: "Don't have an account? ", am: 'መለያ የለዎትም? ' },
    hasAccount: { en: 'Already have an account? ', am: 'መለያ አለዎት? ' },
    subtitle: { en: 'Intelligent Mango Health Monitoring', am: 'ብልህ የማንጎ ጤና ክትትል' },
    serverError: { en: 'Cannot connect to server. Is the backend running?', am: 'ከሰርቨር ጋር መገናኘት አልተቻለም።' },
    registrationFailed: { en: 'Registration failed', am: 'ምዝገባ አልተሳካም' },
    invalidCredentials: { en: 'Invalid credentials', am: 'የተሳሳተ መረጃ' },
  },

  // ---- User Profile ----
  profile: {
    title: { en: 'Your Profile', am: 'የእርስዎ መገለጫ' },
    viewProfile: { en: 'View Profile', am: 'መገለጫ ይመልከቱ' },
    editProfile: { en: 'Edit Profile', am: 'መገለጫ አርትዕ' },
    displayName: { en: 'Display Name', am: 'የማሳያ ስም' },
    enterDisplayName: { en: 'Enter your display name', am: 'የማሳያ ስምዎን ያስገቡ' },
    saveProfile: { en: 'Save Profile', am: 'መገለጫ አስቀምጥ' },
    profileSaved: { en: 'Profile saved successfully', am: 'መገለጫ በተሳካ ሁኔታ ተቀምጧል' },
    saveFailed: { en: 'Failed to save profile', am: 'መገለጫ ማስቀመጥ አልተሳካም' },
    noEmail: { en: 'No email set', am: 'ኢሜይል አልተዘጋጀም' },
    clickToUpload: { en: 'Click to upload photo', am: 'ፎቶ ለመጫን ይጫኑ' },
    invalidImageType: { en: 'Please select an image file', am: 'እባክዎ የምስል ፋይል ይምረጡ' },
    imageTooLarge: { en: 'Image must be less than 1MB', am: 'ምስሉ ከ1MB በታች መሆን አለበት' },
    changePassword: { en: 'Change Password', am: 'የይለፍ ቃል ይቀይሩ' },
    currentPassword: { en: 'Current Password', am: 'አሁን ያለው የይለፍ ቃል' },
    newPassword: { en: 'New Password', am: 'አዲስ የይለፍ ቃል' },
    confirmPassword: { en: 'Confirm Password', am: 'የይለፍ ቃል ያረጋግጡ' },
    updatePassword: { en: 'Update Password', am: 'የይለፍ ቃል አዘምን' },
    passwordChanged: { en: 'Password changed successfully', am: 'የይለፍ ቃል በተሳካ ሁኔታ ተቀይሯል' },
    passwordChangeFailed: { en: 'Failed to change password', am: 'የይለፍ ቃል መቀየር አልተሳካም' },
    passwordMismatch: { en: 'Passwords do not match', am: 'የይለፍ ቃሎች አይዛመዱም' },
    passwordTooShort: { en: 'Password must be at least 6 characters', am: 'የይለፍ ቃል ቢያንስ 6 ቁምፊዎች መሆን አለበት' },
    usernameCannotChange: { en: 'Username cannot be changed', am: 'የተጠቃሚ ስም መቀየር አይቻልም' },
  },

  // ---- Disease Status Card ----
  disease: {
    healthStatus: { en: 'Health Status', am: 'የጤና ሁኔታ' },
    diseaseStatus: { en: 'Disease Status', am: 'የበሽታ ሁኔታ' },
    noData: { en: 'No data available', am: 'ምንም መረጃ የለም' },
    confidence: { en: 'confidence', am: 'እምነት' },
    lastScan: { en: 'Last Scan:', am: 'የመጨረሻ ምርመራ:' },
    loading: { en: 'Loading...', am: 'እየጫነ ነው...' },
    healthy: { en: 'Healthy', am: 'ጤናማ' },
    anthracnose: { en: 'Anthracnose', am: 'አንትራክኖዝ' },
    powderyMildew: { en: 'Powdery Mildew', am: 'የዱቄት ሻጋታ' },
    dieBack: { en: 'Die Back', am: 'ዳይ ባክ' },
    waitingForDevice: { en: 'Waiting for device data', am: 'የመሳሪያ መረጃ በመጠባበቅ ላይ' },
    noRecentDeviceData: { en: 'No recent device data in the last few minutes.', am: 'ባለፉት ጥቂት ደቂቃዎች አዲስ የመሳሪያ መረጃ የለም።' },
  },

  // ---- Sensor Cards ----
  sensor: {
    temperature: { en: 'Temperature', am: 'ሙቀት' },
    humidity: { en: 'Humidity', am: 'እርጥበት' },
    awaitingReading: { en: 'Awaiting fresh reading', am: 'አዲስ ንባብ በመጠባበቅ ላይ' },
  },

  // ---- Historical Chart ----
  chart: {
    title: { en: 'Historical Trends', am: 'ታሪካዊ አዝማሚያዎች' },
    noData: { en: 'No data available', am: 'ምንም መረጃ የለም' },
    loadingData: { en: 'Loading data...', am: 'መረጃ እየጫነ ነው...' },
    waitingForHistory: { en: 'Historical data will appear after your device sends more readings.', am: 'መሳሪያዎ ተጨማሪ ንባቦችን ካስገባ በኋላ ታሪካዊ መረጃ ይታያል።' },
    tempAxis: { en: 'Temp (°C) / Humidity (%)', am: 'ሙቀት (°C) / እርጥበት (%)' },
    tempLabel: { en: 'Temperature (°C)', am: 'ሙቀት (°C)' },
    humidityLabel: { en: 'Humidity (%)', am: 'እርጥበት (%)' },
  },

  // ---- Recommendations ----
  rec: {
    title: { en: 'Recommendations', am: 'ምክሮች' },
    loading: { en: 'Loading recommendations...', am: 'ምክሮችን እየጫነ ነው...' },
    tip: { en: 'Tip', am: 'ምክር' },
    tips: { en: 'Tips', am: 'ምክሮች' },
    viewAll: { en: 'View all recommendations', am: 'ሁሉንም ምክሮች ይመልከቱ' },
    showLess: { en: 'Show less', am: 'ያነሰ ያሳዩ' },
    allHealthy: { en: 'All Systems Healthy', am: 'ሁሉም ስርዓቶች ጤናማ ናቸው' },
    allHealthyDesc: {
      en: 'No active alerts. Continue monitoring and maintain regular maintenance.',
      am: 'ምንም ማንቂያዎች የሉም። መደበኛ ክትትልና ጽዳት ይቀጥሉ።',
    },
    noRecentAdvice: { en: 'Fresh recommendations will appear after the next sync from your device.', am: 'ቀጣዩ የመሳሪያ ማመሳሰል በኋላ አዲስ ምክሮች ይታያሉ።' },
  },

  // ---- Forecast ----
  forecast: {
    title: { en: 'Disease Risk Forecast', am: 'የበሽታ ስጋት ትንበያ' },
    loading: { en: 'Loading forecast...', am: 'ትንበያ እየጫነ ነው...' },
    noData: { en: 'No forecast data available', am: 'ምንም የትንበያ መረጃ የለም' },
    forecastDate: { en: 'Forecast date:', am: 'የትንበያ ቀን:' },
    tomorrow: { en: 'Tomorrow', am: 'ነገ' },
    stable: { en: 'Stable', am: 'የተረጋጋ' },
    anthracnoseRisk: { en: 'Anthracnose Risk', am: 'የአንትራክኖዝ ስጋት' },
    mildewRisk: { en: 'Mildew Risk', am: 'የሻጋታ ስጋት' },
    source: { en: 'Generated on-device (ESP32 XGBoost)', am: 'በመሳሪያ ላይ የተፈጠረ (ESP32 XGBoost)' },
    waitingForForecast: { en: 'Forecast data has not been uploaded yet. Run another device sync to generate outlook cards.', am: 'የትንበያ መረጃ ገና አልተላከም። የእይታ ካርዶችን ለመፍጠር ሌላ የመሳሪያ ማመሳሰል ያካሂዱ።' },
  },

  // ---- Logs Page ----
  logs: {
    title: { en: 'Detection History', am: 'የምርመራ ታሪክ' },
    loading: { en: 'Loading detection history...', am: 'የምርመራ ታሪክ እየጫነ ነው...' },
    empty: { en: 'No detection history available', am: 'ምንም የምርመራ ታሪክ የለም' },
    timestamp: { en: 'Timestamp', am: 'ጊዜ' },
    diseaseClass: { en: 'Disease Class', am: 'የበሽታ ዓይነት' },
    source: { en: 'Source', am: 'ምንጭ' },
    sourceGateway: { en: 'Gateway', am: 'ጌትዌይ' },
    sourceWebApp: { en: 'Web/App', am: 'ድር/መተግበሪያ' },
    confidence: { en: 'Confidence', am: 'እምነት' },
    temperature: { en: 'Temperature', am: 'ሙቀት' },
    humidity: { en: 'Humidity', am: 'እርጥበት' },
    previous: { en: '← Previous', am: '← ቀዳሚ' },
    next: { en: 'Next →', am: 'ቀጣይ →' },
    pageOf: { en: 'Page', am: 'ገጽ' },
    of: { en: 'of', am: 'ከ' },
    total: { en: 'total', am: 'ጠቅላላ' },
    exportZip: { en: 'Export Zip', am: 'Zip አውርድ' },
    emptyHint: { en: 'Logs will start filling in after the next successful disease scan upload.', am: 'ቀጣዩ የተሳካ የበሽታ ስካን ማስገባት በኋላ ሎጎች ይሞላሉ።' },
  },

  // ---- Settings Page ----
  settings: {
    failedRegisterDevice: { en: 'Failed to register device', am: 'መሳሪያ መመዝገብ አልተሳካም' },
    networkError: { en: 'Network error', am: 'የኔትወርክ ስህተት' },
    unknownError: { en: 'Unknown error', am: 'ያልታወቀ ስህተት' },
    hardwareGateways: { en: 'Hardware Gateways', am: 'የሃርድዌር ጌትዌዎች' },
    hardwareGatewaysDesc: { en: 'Connect and manage your ESP32/ESP8266 field devices', am: 'የእርስዎን ESP32/ESP8266 የመስክ መሳሪያዎች ያገናኙ እና ያስተዳድሩ' },
    addGateway: { en: 'Add Gateway', am: 'ጌትዌይ ጨምር' },
    noGatewaysConnectedYet: { en: 'No Gateways Connected Yet', am: 'እስካሁን ምንም ጌትዌይ አልተገናኘም' },
    addGatewayHelp: { en: 'Use the "Add Gateway" button above to register your first hardware gateway', am: 'የመጀመሪያዎን የሃርድዌር ጌትዌይ ለመመዝገብ ከላይ ያለውን "ጌትዌይ ጨምር" ቁልፍ ይጠቀሙ' },
    ready: { en: 'Ready', am: 'ዝግጁ' },
    online: { en: 'Online', am: 'በመስመር ላይ' },
    offline: { en: 'Offline', am: 'ከመስመር ውጭ' },
    gatewayDevice: { en: 'Gateway Device', am: 'የጌትዌይ መሳሪያ' },
    idLabel: { en: 'ID', am: 'መለያ' },
    apiKey: { en: 'API Key', am: 'API ቁልፍ' },
    copyApiKey: { en: 'Copy full API key', am: 'ሙሉ API ቁልፍ ቅዳ' },
    copy: { en: 'Copy', am: 'ቅዳ' },
    copied: { en: 'Copied', am: 'ተቀድቷል' },
    setupInstructions: { en: 'Setup Instructions', am: 'የማዋቀር መመሪያዎች' },
    setupStep1: { en: '1. Open Config.h on your device:', am: '1. በመሳሪያዎ ላይ Config.h ይክፈቱ:' },
    setupStep2: { en: '2. Upload and restart your device', am: '2. መሳሪያዎን ይጫኑ እና እንደገና ያስጀምሩ' },
    generateNewApiKey: { en: 'Generate new API key', am: 'አዲስ API ቁልፍ ፍጠር' },
    regenerate: { en: 'Regenerate', am: 'እንደገና ፍጠር' },
    removeGateway: { en: 'Remove gateway', am: 'ጌትዌዩን አስወግድ' },
    remove: { en: 'Remove', am: 'አስወግድ' },
    chooseLanguage: { en: 'Choose your preferred interface language', am: 'የሚመርጡትን የመጠቀሚያ ቋንቋ ይምረጡ' },
    english: { en: 'English', am: 'እንግሊዝኛ' },
    amharic: { en: 'Amharic', am: 'አማርኛ' },
    displayPreferencesDesc: { en: 'Customize how content is displayed', am: 'ይዘት እንዴት እንደሚታይ ያብጁ' },
    celsius: { en: 'Celsius', am: 'ሴልሺየስ' },
    fahrenheit: { en: 'Fahrenheit', am: 'ፋረንሃይት' },
    relative: { en: 'Relative', am: 'አንፃራዊ' },
    absolute: { en: 'Absolute', am: 'ፍጹም' },
    relativeExample: { en: '2 mins ago', am: 'ከ2 ደቂቃ በፊት' },
    absoluteExample: { en: '4:30 PM', am: '4:30 ከሰዓት' },
    dataSyncDesc: { en: 'Control how often data updates', am: 'ውሂብ ምን ያህል ጊዜ እንዲዘምን ይቆጣጠሩ' },
    autoRefreshInterval: { en: 'Auto-Refresh Interval', am: 'በራስ-ሰር የማደሻ ጊዜ' },
    manual: { en: 'Manual', am: 'በእጅ' },
    current: { en: 'Current', am: 'አሁን' },
    every: { en: 'Every', am: 'በየ' },
    notificationsAlerts: { en: 'Notifications and Alerts', am: 'ማሳወቂያዎች እና ማንቂያዎች' },
    notificationsAlertsDesc: { en: 'Configure detection alerts and thresholds', am: 'የግኝት ማንቂያዎችን እና ወሰኖችን ያዋቅሩ' },
    pushNotifications: { en: 'Email Notifications', am: 'የኢሜይል ማሳወቂያዎች' },
    pushNotificationsDesc: { en: 'Receive email alerts on disease detection', am: 'በሽታ ሲገኝ የኢሜይል ማንቂያ ይቀበሉ' },
    browserOnlyNote: { en: 'Display, time, and refresh preferences only affect this browser.', am: 'የማሳያ፣ የሰዓት እና የማደሻ ምርጫዎች በዚህ አሳሽ ላይ ብቻ ይተገበራሉ።' },
    serverDrivenNote: { en: 'Notifications depend on backend rules, device uploads, and your saved contact details.', am: 'ማሳወቂያዎች በጀርባ ስርዓት ህጎች፣ በመሳሪያ ማስገባቶች እና በተቀመጡ የመገኛ መረጃዎች ይወሰናሉ።' },
    low: { en: 'Low', am: 'ዝቅተኛ' },
    medium: { en: 'Medium', am: 'መካከለኛ' },
    high: { en: 'High', am: 'ከፍተኛ' },
    saveChanges: { en: 'Save Changes', am: 'ለውጦችን አስቀምጥ' },
    allChangesSaved: { en: 'All changes saved successfully', am: 'ሁሉም ለውጦች በተሳካ ሁኔታ ተቀምጠዋል' },
    alertThresholds: { en: 'Alert Thresholds', am: 'የማንቂያ ወሰኖች' },
    minTemp: { en: 'Minimum Temperature (°C)', am: 'ዝቅተኛ ሙቀት (°C)' },
    maxTemp: { en: 'Maximum Temperature (°C)', am: 'ከፍተኛ ሙቀት (°C)' },
    minHumidity: { en: 'Minimum Humidity (%)', am: 'ዝቅተኛ እርጥበት (%)' },
    maxHumidity: { en: 'Maximum Humidity (%)', am: 'ከፍተኛ እርጥበት (%)' },
    notifications: { en: 'Notifications', am: 'ማሳወቂያዎች' },
    enablePush: { en: 'Enable Push Notifications', am: 'ማሳወቂያዎችን አንቃ' },
    confidenceThreshold: { en: 'Disease Alert Confidence Threshold', am: 'የበሽታ ማንቂያ እምነት ወሰን' },
    confidenceHint: { en: 'Only notify when disease detection confidence exceeds this level', am: 'የበሽታ ግኝት እምነት ከዚህ ደረጃ ሲበልጥ ብቻ አሳውቅ' },
    systemInfo: { en: 'System Information', am: 'የስርዓት መረጃ' },
    deviceId: { en: 'Device ID:', am: 'የመሳሪያ ኮድ:' },
    firmware: { en: 'Firmware Version:', am: 'የስርዓት ስሪት:' },
    lastSync: { en: 'Last Sync (EAT):', am: 'የመጨረሻ ማመሳሰል:' },


    save: { en: 'Save Settings', am: 'ቅንብሮችን አስቀምጥ' },
    general: { en: 'General Settings', am: 'አጠቃላይ ቅንብሮች' },
    language: { en: 'Language', am: 'ቋንቋ' },
    displayPreferences: { en: 'Display Preferences', am: 'የማሳያ ምርጫዎች' },
    temperatureUnit: { en: 'Temperature Unit', am: 'የሙቀት መለኪያ' },
    timeFormat: { en: 'Time Format', am: 'የሰዓት አቀራረብ' },
    timeFormatHint: { en: 'How timestamps are displayed on charts and logs.', am: 'የጊዜ ምልክቶች በቻርትና ሎግ ላይ እንዴት እንደሚታዩ።' },
    dataSync: { en: 'Data Synchronization', am: 'የውሂብ ማመሳሰል' },
    autoRefresh: { en: 'Dashboard Auto-Refresh Interval', am: 'ዳሽቦርድ በራስ ሰር የማደሻ ጊዜ' },
    autoRefreshHint: { en: 'How often the dashboard should automatically pull new sensor data.', am: 'ዳሽቦርዱ አዲስ የሴንሰር መረጃዎችን ምን ያህል ጊዜ በራስ-ሰር ማሳየት እንዳለበት።' },

    saved: { en: 'Settings saved', am: 'ቅንብሮች ተቀምጠዋል' },
    deviceConnection: { en: 'Device Connection', am: 'የመሳሪያ ግንኙነት' },
    apiEndpoint: { en: 'API Endpoint', am: 'API መንገድ' },
    noDevices: { en: 'No devices connected yet. Generate a key to link your ESP32.', am: 'ምንም መሳሪያ አልተገናኘም። ESP32ን ለማገናኘት ቁልፍ ይፍጠሩ።' },
    generateKey: { en: 'Generate Device Key', am: 'የመሳሪያ ቁልፍ ፍጠር' },
    deviceApiKey: { en: 'Device API Key', am: 'የመሳሪያ API ቁልፍ' },
    connected: { en: 'Connected', am: 'ተገናኝቷል' },
    neverConnected: { en: 'Never connected', am: 'በጭራሽ አልተገናኘም' },
    lastSeen: { en: 'Last seen', am: 'ለመጨረሻ ጊዜ የታየ' },
    esp32Config: { en: 'ESP32 Config.h', am: 'ESP32 Config.h' },
    noDevicesConnectedYet: { en: 'No devices connected yet', am: 'እስካሁን ምንም መሳሪያ አልተገናኘም' },
  },

  // ---- Analysis Page ----
  analysis: {
    title: { en: 'Advanced Analysis', am: 'የተራቀቀ ትንተና' },
    loading: { en: 'Loading analysis...', am: 'ትንተና እየጫነ ነው...' },
    scanTitle: { en: 'TinyML Scan', am: 'የታይኒኤምኤል ስካን' },
    scanReadyStatus: { en: 'Ready', am: 'ዝግጁ' },
    scanPendingStatus: { en: 'Pending', am: 'በመጠባበቅ ላይ' },
    scanCompletedStatus: { en: 'Completed', am: 'ተጠናቋል' },
    scanReadyBody: { en: 'Trigger a fresh on-device leaf scan using your Edge Impulse model. The gateway polls for commands every 5 seconds and runs the scan on demand.', am: 'የEdge Impulse ሞዴልዎን ተጠቅመው አዲስ የቅጠል ስካን ያስጀምሩ። ጌትዌዩ በ5 ሰከንድ ልዩነት ትዕዛዞችን ይመለከታል እና ስካኑን በጥያቄ ጊዜ ያስኬዳል።' },
    scanPendingBody: { en: 'A scan command is waiting at the gateway. The device will pick it up on the next poll and upload the result for this request.', am: 'የስካን ትዕዛዝ በጌትዌዩ ላይ በመጠባበቅ ላይ ነው። መሳሪያው በቀጣዩ ምርመራ ጊዜ ይወስደዋል እና ውጤቱን ለዚህ ጥያቄ ይልካል።' },
    scanCompletedBody: { en: 'The latest requested scan has finished. You can trigger another on-demand Edge Impulse capture any time.', am: 'የመጨረሻው የተጠየቀ ስካን ተጠናቋል። በማንኛውም ጊዜ ሌላ በጥያቄ የሚሰራ የEdge Impulse ስካን ማስጀመር ይችላሉ።' },
    scanNoDeviceBody: { en: 'No gateway is connected yet. You can still use the header quick scan to save a web/app result, but gateway TinyML requests stay unavailable until a device is registered.', am: 'ጌትዌይ ገና አልተገናኘም። ነገር ግን ከራስጌው ያለውን ፈጣን ስካን በመጠቀም የድር/መተግበሪያ ውጤት ማስቀመጥ ይችላሉ፤ የጌትዌይ TinyML ጥያቄዎች ግን መሳሪያ እስኪመዘገብ ድረስ አይኖሩም።' },
    scanRunAction: { en: 'Run Scan', am: 'ስካን አስኪድ' },
    scanPendingAction: { en: 'Scan Pending', am: 'ስካኑ በመጠባበቅ ላይ ነው' },
    scanQueueHint: { en: 'The gateway polls `/scan/pending` every 5 seconds and uploads the matching result with its request ID.', am: 'ጌትዌዩ `/scan/pending` ን በ5 ሰከንድ ልዩነት ይመለከታል እና ተመሳሳይ ውጤቱን ከrequest ID ጋር ይልካል።' },
    scanTargetDevice: { en: 'Target Device', am: 'የታለመ መሳሪያ' },
    scanLatestResult: { en: 'Latest Requested Result', am: 'የመጨረሻው የተጠየቀ ውጤት' },
    scanQueuedAt: { en: 'Queued At', am: 'የተሰለፈበት ጊዜ' },
    scanCompletedAt: { en: 'Completed At', am: 'የተጠናቀቀበት ጊዜ' },
    scanWaitingResult: { en: 'Waiting for a scan result', am: 'የስካን ውጤት በመጠባበቅ ላይ' },
    scanModelDefault: { en: 'Edge Impulse EfficientNet', am: 'Edge Impulse EfficientNet' },
    scanDeviceIdleHint: { en: 'No gateway heartbeat has been recorded yet.', am: 'የጌትዌዩ የእንቅስቃሴ ምልክት ገና አልተመዘገበም።' },
    scanResultStoredHint: { en: 'Completed scan results reuse the normal detection history.', am: 'የተጠናቀቁ የስካን ውጤቶች መደበኛውን የግኝት ታሪክ ይጠቀማሉ።' },
    scanRequestStored: { en: 'The request timestamp is stored separately from the detection itself.', am: 'የጥያቄው ጊዜ ከራሱ የግኝት መረጃ ተለይቶ ይቀመጣል።' },
    scanCompletionHint: { en: 'Completion is stamped when the requested inference upload returns with the same request ID.', am: 'የተጠየቀው የትንበያ ማስገባት ከተመሳሳይ request ID ጋር ሲመጣ የተጠናቀቀ ጊዜ ይመዘገባል።' },
    notAvailable: { en: 'N/A', am: 'መረጃ የለም' },
    totalScans: { en: 'Total Scans', am: 'ጠቅላላ ምርመራዎች' },
    healthyRate: { en: 'Healthy Rate', am: 'የጤናማነት መጠን' },
    riskLevel: { en: 'Risk Level', am: 'የስጋት ደረጃ' },
    topDisease: { en: 'Top Disease', am: 'በጣም የተደጋገመ በሽታ' },
    healthyDetections: { en: 'Healthy detections', am: 'ጤናማ ግኝቶች' },
    diseaseDetections: { en: 'Disease detections', am: 'የበሽታ ግኝቶች' },
    healthyAvgTemp: { en: 'Healthy avg temp', am: 'የጤናማ አማካይ ሙቀት' },
    diseaseAvgTemp: { en: 'Disease avg temp', am: 'የበሽታ አማካይ ሙቀት' },
    healthyAvgHumidity: { en: 'Healthy avg humidity', am: 'የጤናማ አማካይ እርጥበት' },
    diseaseAvgHumidity: { en: 'Disease avg humidity', am: 'የበሽታ አማካይ እርጥበት' },
    compositeRiskScore: { en: 'Orchard Risk Score', am: 'የማሳያ ስጋት ውጤት' },
    recentDiseaseRatio: { en: 'Recent disease ratio', am: 'የቅርብ ጊዜ የበሽታ መጠን' },
    averageConfidence: { en: 'Scan Reliability', am: 'የምርመራ አስተማማኝነት' },
    forecastHighRiskDays: { en: 'Forecast high-risk days', am: 'ትንበያ ከፍተኛ ስጋት ቀናት' },
    totalRecommendations: { en: 'Total recommendations', am: 'ጠቅላላ ምክሮች' },
    latestRecommendation: { en: 'Latest recommendation', am: 'የመጨረሻ ምክር' },
    forecastStableDays: { en: 'Forecast stable days', am: 'ትንበያ የተረጋጉ ቀናት' },
    sensorSamples30d: { en: 'Sensor samples (30d)', am: 'የሴንሰር ናሙናዎች (30 ቀን)' },
    diseaseBreakdown: { en: 'Disease breakdown', am: 'የበሽታ ክፍፍል' },
    temperatureTrend: { en: 'Temperature trend', am: 'የሙቀት አዝማሚያ' },
    recentConfidenceTrend: { en: 'Recent confidence trend', am: 'የቅርብ እምነት አዝማሚያ' },
    forecastOutlook: { en: 'Forecast outlook', am: 'የትንበያ አጠቃላይ እይታ' },
    topRecommendations: { en: 'Top recommendations', am: 'ዋና ምክሮች' },
    liveOverview: { en: 'Live overview', am: 'የቀጥታ አጠቃላይ እይታ' },
    overviewStableTitle: { en: 'Conditions look stable', am: 'ሁኔታዎች የተረጋጉ ይመስላሉ' },
    overviewStableBody: { en: 'Recent scans suggest the orchard is mostly healthy, with limited short-term disease pressure.', am: 'የቅርብ ጊዜ ምርመራዎች ማሳያው አብዛኛውን ጊዜ ጤናማ እንደሆነ እና የቅርብ ጊዜ የበሽታ ጫና ዝቅተኛ እንደሆነ ያሳያሉ።' },
    overviewWatchTitle: { en: 'Conditions need closer watching', am: 'ሁኔታዎች የበለጠ ቅርብ ክትትል ይፈልጋሉ' },
    overviewWatchBody: { en: 'Signals are mixed enough that temperature, humidity, and disease detections deserve closer attention.', am: 'ምልክቶቹ የተቀላቀሉ ስለሆኑ ሙቀት፣ እርጥበት እና የበሽታ ግኝቶች ቅርብ እይታ ይፈልጋሉ።' },
    overviewHighRiskTitle: { en: 'Disease pressure is elevated — act now', am: 'የበሽታ ጫና ከፍ ብሏል — አሁን እርምጃ ይውሰዱ' },
    overviewHighRiskBody: { en: 'Recent scans found disease on your mango leaves. Apply a copper-based fungicide (e.g. Copper Oxychloride) within 48 hours to protect the orchard.', am: 'በቅርብ ምርመራዎች በማንጎ ቅጠሎች ላይ በሽታ ተገኝቷል። ማሳውን ለመጠበቅ በ48 ሰዓታት ውስጥ የመዳብ ፈንገስ ማጥፊያ (ለምሳሌ ኮፐር ኦክሲክሎራይድ) ይርጩ።' },
    noAnalysisDataTitle: { en: 'Analysis will appear after uploads arrive', am: 'መረጃ ከተላከ በኋላ ትንተና ይታያል' },
    noAnalysisDataBody: { en: 'Run a few sensor syncs and disease scans to unlock trends, risk signals, and recommendation summaries.', am: 'አዝማሚያዎችን፣ የስጋት ምልክቶችን እና የምክር ማጠቃለያዎችን ለማየት ጥቂት የሴንሰር ማመሳሰሎችን እና የበሽታ ስካኖችን ያካሂዱ።' },
    scanBalance: { en: 'Scan balance', am: 'የምርመራ ሚዛን' },
    diseaseShare: { en: 'Disease share', am: 'የበሽታ ድርሻ' },
    dataCoverage: { en: 'Sensor Activity', am: 'የሴንሰር እንቅስቃሴ' },
    topDriver: { en: 'Main Risk Factor', am: 'ዋናው የስጋት ምክንያት' },
    environmentSnapshot: { en: 'Environment snapshot', am: 'የአካባቢ ፈጣን እይታ' },
    healthyBaseline: { en: 'Healthy baseline', am: 'የጤናማ መነሻ' },
    diseaseBaseline: { en: 'Disease baseline', am: 'የበሽታ መነሻ' },
    gapVsHealthy: { en: 'Health Comparison', am: 'የጤና ንጽጽር' },
    riskSignals: { en: 'Risk signals', am: 'የስጋት ምልክቶች' },
    recommendationFocus: { en: 'Recommendation focus', am: 'የምክር ትኩረት' },
    recommendationSpotlight: { en: 'Recommendation spotlight', am: 'የምክር ዋና ነጥብ' },
    noRecommendationYet: { en: 'No recommendation recorded yet', am: 'እስካሁን ምንም ምክር አልተመዘገበም' },
    confidenceSignal: { en: 'Scan Reliability', am: 'የምርመራ አስተማማኝነት' },
    highRiskDays: { en: 'High-risk days', am: 'ከፍተኛ ስጋት ቀናት' },
    healthyOnlyBreakdown: { en: 'Only healthy detections have been recorded so far.', am: 'እስካሁን የተመዘገቡት ጤናማ ግኝቶች ብቻ ናቸው።' },
    insightsLive: { en: 'Insights are computed live from your field sensors.', am: 'ትንታኔው ከእርሻዎ ሴንሰሮች በቀጥታ ይሰላል።' },
    lastScanned: { en: 'Last scanned:', am: 'ለመጨረሻ ጊዜ የተመረመረው:' },
    actionNoAction: { en: 'No immediate action needed — keep monitoring', am: 'አሁን የሚፈለግ አስቸኳይ እርምጃ የለም — ክትትሉን ይቀጥሉ' },
    actionSpray: { en: 'Apply copper fungicide (e.g. Copper Oxychloride) within 48 hours', am: 'በ48 ሰዓታት ውስጥ የመዳብ ፈንገስ ማጥፊያ (ለምሳሌ ኮፐር ኦክሲክሎራይድ) ይርጩ' },
    actionMonitor: { en: 'Inspect leaves daily and prepare fungicide spray if spots appear', am: 'ቅጠሎችን በየቀኑ ይመርምሩ እና ነጠብጣቦች ከታዩ የፈንገስ ማጥፊያ ለመርጨት ይዘጋጁ' },
    low: { en: 'Low', am: 'ዝቅተኛ' },
    medium: { en: 'Medium', am: 'መካከለኛ' },
    high: { en: 'High', am: 'ከፍተኛ' },
    diseasePatterns: { en: 'Disease Patterns', am: 'የበሽታ ዘይቤዎች' },
    diseasePatternsDesc: { en: 'Historical disease occurrence patterns and recent trends', am: 'ታሪካዊ የበሽታ ክስተት ዘይቤዎች እና የቅርብ ጊዜ አዝማሚያዎች' },
    envCorrelations: { en: 'Environmental Correlations', am: 'የአካባቢ ግንኙነቶች' },
    envCorrelationsDesc: { en: 'Relationships between environmental conditions and disease detection', am: 'በአካባቢ ሁኔታዎች እና በሽታ ግኝት መካከል ያለው ግንኙነት' },
    riskAssessment: { en: 'Risk Assessment', am: 'የአደጋ ግምገማ' },
    riskAssessmentDesc: { en: 'Long-term risk evaluation based on historical data', am: 'በታሪካዊ መረጃ ላይ የተመሰረተ የረጅም ጊዜ ግምገማ' },
    recSummary: { en: 'Recommendations Summary', am: 'የምክሮች ማጠቃለያ' },
    recSummaryDesc: { en: 'Aggregate view of all recommendations provided over time', am: 'በጊዜ ሂደት የተሰጡ ምክሮች ማጠቃለያ' },
    comingSoon: { en: 'Detailed analytics dashboard coming soon. Use the Logs page to review detection history.', am: 'ዝርዝር ትንተና ዳሽቦርድ በቅርቡ ይመጣል። የምርመራ ታሪክን ለመመልከት የመዝገቦች ገጽን ይጠቀሙ።' },
  },

  // ---- Quick Scan Modal ----
  quickScan: {
    title: { en: 'Quick Scan', am: 'ፈጣን ስካን' },
    subtitle: { en: 'Upload a leaf photo from the web app and save the result without waiting for a gateway.', am: 'ጌትዌይ ሳይጠበቅ ከድር መተግበሪያው የቅጠል ፎቶ ይጫኑ እና ውጤቱን ያስቀምጡ።' },
    storageHint: { en: 'This stores the scan on the backend as a web/app run, so logs and analysis update even when no gateway is connected.', am: 'ይህ ስካኑን በጀርባ ስርዓቱ ላይ እንደ ድር/መተግበሪያ ስራ ያስቀምጣል፤ ስለዚህ ጌትዌይ ባይኖርም ሎጎችና ትንተናዎች ይዘምናሉ።' },
    pickImage: { en: 'Select Leaf Image', am: 'የቅጠል ምስል ይምረጡ' },
    pickImageHint: { en: 'Tap to upload or capture a fresh photo.', am: 'ለመጫን ወይም አዲስ ፎቶ ለመንሳት ይጫኑ።' },
    changeImage: { en: 'Change Image', am: 'ምስል ቀይር' },
    runAction: { en: 'Run Web Scan', am: 'የድር ስካን አስኪድ' },
    previewAlt: { en: 'Leaf scan preview', am: 'የቅጠል ስካን ቅድመ እይታ' },
    invalidImageType: { en: 'Please choose an image file.', am: 'እባክዎ የምስል ፋይል ይምረጡ።' },
    fileTooLarge: { en: 'Image must be smaller than 8MB.', am: 'ምስሉ ከ8MB በታች መሆን አለበት።' },
    scanFailed: { en: 'Scan failed. Please try another image.', am: 'ስካኑ አልተሳካም። እባክዎ ሌላ ምስል ይሞክሩ።' },
  },

  // ---- Footer ----
  footer: {
    text: {
      en: '© 2026 MangoGuard - Intelligent Mango Health Monitoring.',
      am: '© 2026 MangoGuard - ብልህ የማንጎ ጤና ክትትል።',
    },
  },

  // ---- Common ----
  common: {
    loading: { en: 'Loading...', am: 'እየጫነ ነው...' },
    error: { en: 'Error', am: 'ስህተት' },
    retry: { en: 'Retry', am: 'ድገም' },
    errorLoading: { en: 'Error loading dashboard:', am: 'ዳሽቦርድ መጫን አልተሳካም:' },
    lastUpdated: { en: 'Last updated', am: 'ለመጨረሻ ጊዜ የተዘመነ' },
    live: { en: 'Live', am: 'በቀጥታ' },
    delayed: { en: 'Delayed', am: 'የዘገየ' },
    offline: { en: 'Offline', am: 'ከመስመር ውጭ' },
    healthy: { en: 'Healthy', am: 'ጤናማ' },
    unavailable: { en: 'Unavailable', am: 'አይገኝም' },
    browserOnly: { en: 'Browser only', am: 'በአሳሽ ብቻ' },
    backendDriven: { en: 'Backend driven', am: 'በጀርባ ስርዓት የሚተዳደር' },
    custom: { en: 'Custom...', am: 'ብጁ...' },
    enterCustomLabel: { en: 'Enter custom label', am: 'ብጁ ስያሜ ያስገቡ' },
    addDevice: { en: 'Add Device', am: 'መሳሪያ ጨምር' },
    selectUser: { en: 'Select User', am: 'ተጠቃሚ ይምረጡ' },
    deviceName: { en: 'Device Name', am: 'የመሳሪያ ስም' },
    createDevice: { en: 'Create Device', am: 'መሳሪያ ፍጠር' },
    cancel: { en: 'Cancel', am: 'ሰርዝ' },
    close: { en: 'Close', am: 'ዝጋ' },
    manage: { en: 'Manage', am: 'ያስተዳድሩ' },
    confirm: { en: 'Confirm', am: 'አረጋግጥ' },
  },
};

export default translations;
